import { Form, Formik } from 'formik';
import SelectBox from '../../shared/controls/form/selectBox';
import { CheckBox, DateBox, TextArea, TextBox } from '../../shared/controls/form';
import { useSelector } from 'react-redux';
import { getActiveOwners, getGenericMasterFilteredListByKey } from '../../redux/selector';
import { validationSchemaPrice } from './priceValidationSchema';

const PriceForm = ({
  formData,
  selectedOptions,
  handleSubmit,
  handleChangeForm,
  handleChange,
  errormsg,
  handleChangeCheckbox,
  refs,
}) => {
  const currency = useSelector(getGenericMasterFilteredListByKey('Currency'));
  const owner = useSelector(getActiveOwners);
  const priceModel = useSelector(getGenericMasterFilteredListByKey('PriceModel'));

  return (
    <Formik
      initialValues={formData}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={validationSchemaPrice}
    >
      <Form>
        <div className={formData?.type === 'view' ? 'addleadcard-view' : 'addleadcard'}>
          <div className="row gx-3">
            <div className="col-12 col-sm-12 col-md-12">
              <div className="infoBox">
                <div className="addlead-header pd_card">
                  <label htmlFor="" className="flex-div align-items-center">
                    <img className="me-2" src="../assets/quoteAi/images/quoteInfo.svg" alt="" />
                    Price Sheet Information
                  </label>
                </div>
                <div className="quoteContent leadDetailInfo ">
                  <>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <SelectBox
                            label="Price Sheet Owner"
                            name="priceSheetOwnerId"
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.priceSheetOwner || '--'
                                : formData?.priceSheetOwner || 'Select Price Sheet Owner'
                            }
                            isRequired={false}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions?.priceSheetOwnerId}
                            handleSelect={handleChange}
                            options={owner}
                            optionKeys={['userId', 'display_name']}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <TextBox
                            isRequired={true}
                            label={'Price Sheet Name'}
                            name={'name'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Price Sheet Name'
                            }
                            value={formData?.name}
                            disabled={formData?.type === 'view'}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.name}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <div className="dateBox">
                            <label>Start Date<span className="required-star">*</span></label>
                            
                            {formData?.type === 'view' && !formData?.startDate ? (
                              <div> --</div>
                            ) : (
                              <div className="dtBox custom-date-wrapper">
                                <DateBox
                                  name={'startDate'}
                                  className="custom-date-input"
                                  placeholder={
                                    formData?.type === 'view'
                                      ? '--'
                                      : 'Enter Start Date (MM/DD/YYYY)'
                                  }
                                  value={
                                    formData?.startDate ? formData?.startDate.substring(0, 10) : ''
                                  }
                                  disabled={formData?.type === 'view'}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.startDate}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <div className="dateBox">
                            <label>End Date<span className="required-star">*</span></label>
                            {formData?.type === 'view' && !formData?.endDate ? (
                              <div> --</div>
                            ) : (
                              <div className="dtBox custom-date-wrapper">
                                <DateBox
                                  name={'endDate'}
                                  className="custom-date-input"
                                  placeholder={
                                    formData?.type === 'view' ? '--' : 'Enter End Date (MM/DD/YYYY)'
                                  }
                                  value={
                                    formData?.endDate ? formData?.endDate.substring(0, 10) : ''
                                  }
                                  disabled={formData?.type === 'view'}
                                  handleChange={handleChangeForm}
                                  errormsg={errormsg?.endDate}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <div className="form-check d-flex align-items-center gap-4 ps-0">
                            <CheckBox
                              label={'Active'}
                              name={'productActive'}
                              checked={formData?.productActive}
                              handleChange={handleChangeCheckbox}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12">
              <div className="infoBox">
                <div className="addlead-header pd_card">
                  <label htmlFor="" className="flex-div align-items-center">
                    <img className="me-2" src="../assets/quoteAi/images/quoteInfo.svg" alt="" />
                    Price Details
                  </label>
                </div>
                <div className="quoteContent leadDetailInfo ">
                  <>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container">
                          <SelectBox
                            label="Price Model"
                            name="priceModelId"
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.priceModel || '--'
                                : formData?.priceModel || 'Select Price Model'
                            }
                            isRequired={false}
                            handleSelect={handleChange}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions?.priceModelId}
                            optionKeys={['id', 'displayName']}
                            options={priceModel}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container mb-2">
                          <SelectBox
                            label={'Currency'}
                            name={'currencyPriceId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.currencyPrice || '--'
                                : formData?.currencyPrice || 'Select Currency'
                            }
                            isRequired={false}
                            disabled={formData?.type === 'view'}
                            options={currency}
                            optionKeys={['id', 'displayName']}
                            handleSelect={handleChange}
                            selectedOptions={selectedOptions?.currencyPriceId}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container mb-2">
                          <TextBox
                            label={'Discount Percent'}
                            type="number"
                            name="discountPercent"
                            className="form-control"
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Discount Percent'
                            }
                            value={formData?.discountPercent ?? ''}
                            disabled={formData?.type === 'view'}
                            handleChange={handleChangeForm}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="input-container mb-2">
                          <TextBox
                            label={'Discount Amount'}
                            type="number"
                            name="discountAmount"
                            className="form-control"
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Discount Amount'
                            }
                            value={formData?.discountAmount ?? ''}
                            disabled={formData?.type === 'view'}
                            handleChange={handleChangeForm}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-12">
              <div className="infoBox">
                <div className="addlead-header pd_card">
                  <label htmlFor="" className="flex-div align-items-center">
                    <img
                      className="me-2"
                      src="../assets/quoteAi/images/additionalInfo.svg"
                      alt=""
                    />
                    Additional Details
                  </label>
                </div>
                <div className="quoteContent leadDetailInfo notesLabel">
                  <>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="input-container blockClass">
                          <TextArea
                            label={'Terms and Conditions'}
                            name={'terms'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Terms and Conditions'
                            }
                            value={formData?.terms}
                            handleChange={handleChangeForm}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="input-container blockClass">
                          <TextArea
                            label={'Description'}
                            name={'description'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Description'}
                            value={formData?.description}
                            handleChange={handleChangeForm}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default PriceForm;
